import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useQuery, useQueryClient } from 'react-query';
import { deleteUser } from 'endpoints/users';
import { toast } from 'react-toastify';
import { isDistributor } from 'utils/distributor';

export default function DeleteUserDialog({
  modalOpen,
  selectedUser,
  handleClose,
}) {
  const queryClient = useQueryClient();
  const { isLoading, refetch } = useQuery(
    'deleteUser',
    () => deleteUser(selectedUser.id), {
      manual: true,
      retry: false,
      refetchOnMount: false,
      enabled: false,
      onError: error => {
        toast.error(error.response.data.message);
      },
      onSuccess: () => {
        toast.success(t('deletedUser'));
        queryClient.refetchQueries(['users']);
        !isDistributor() && queryClient.refetchQueries(['distributors']);
        handleClose();
      },
    },
  );

  const { t } = useTranslation('form');
  return (
    <Dialog open={modalOpen} onClose={handleClose} disableBackdropClick={isLoading} disableEscapeKeyDown={isLoading}>
      <DialogTitle>{t('confirmDelete')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {selectedUser && t('confirmDeleteMessage', { name: selectedUser?.name })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading} variant="outlined" color="default">
          {t('cancel')}
        </Button>
        <Button
          onClick={refetch}
          disabled={isLoading}
          variant="outlined"
          color="primary"
          autoFocus
        >
          {t('clear')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
